module.exports = __webpack_public_path__ + "static/media/iconfont.622ef58c.svg";